import VerificationDetail from 'dashboard/components/VerificationDetail/VerificationDetail';
import { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import { DocumentGeneric } from 'dashboard/models/document';
import { Verification } from 'dashboard/models/verification';
import {
  ResourceVerificationAttributes,
  ResourceVerificationModules,
} from 'dashboard/modules/ResourceVerification/model';
import useCurrentEnvironmentType from 'lib/hooks/useCurrentEnvironmentType';
import { ApiModel } from 'lib/interfaces/api';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

export interface ResourceVerificationProps {
  verification: Verification;
  documents: DocumentGeneric[];
  defaultAccordionOpen: boolean;
  featureFlags: FeatureFlagsMap;
  module?: ResourceVerificationModules;
  handleFlagVerificationIssues?: (
    verification: Verification,
    values: FlagIssuesFormData,
  ) => Promise<void>;
}

export const ResourceVerification = ({
  verification,
  documents,
  defaultAccordionOpen,
  featureFlags,
  module,
  handleFlagVerificationIssues,
}: ResourceVerificationProps) => {
  let attributeList: ResourceVerificationAttributes[];

  const { type: environmentType } = useCurrentEnvironmentType();

  switch (module?.['verification-type']) {
    case ApiModel.VerificationGovernmentId:
      attributeList = module?.attributes;
      break;
    case ApiModel.VerificationSelfie:
      attributeList = module?.attributes;
      break;
  }

  return (
    <VerificationDetail
      verification={verification}
      documents={documents}
      featureFlags={featureFlags}
      isDefaultOpen={defaultAccordionOpen}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      layout={attributeList}
      environmentType={environmentType}
      handleFlagVerificationIssues={handleFlagVerificationIssues}
      exposeId={true}
    />
  );
};

export default ResourceVerification;
